/**
 * Gift cards (ADR-082): a bearer code with a value, redeemed whole into the
 * customer's store credit (ADR-081). Money in halalas.
 */
export const GIFT_CARD_LIMITS = {
    /** Halalas: 10,000.00 a card. */
    maxValue: 10_000_00,
    /** Alike cards issued in one go. */
    maxBatch: 100,
    message: 500,
};
//# sourceMappingURL=gift-cards.js.map